import BttfAxios from '@features/utils/axios';

const AgreementsService = {
  getBrokerAgreement: async (id: string) =>
    await BttfAxios.get(`/api/brokers/agreements/${id}`, resp => resp),
  signBrokerAgreement: async (id: string, pitchId: number) =>
    await BttfAxios.patch(
      `/api/brokers/agreements/${id}?pitch_id=${pitchId}`,
      undefined,
      resp => resp
    ),
  getLicenceAgreement: async (id: string) =>
    await BttfAxios.get(`/api/investor_pitch_licences/${id}`, resp => resp),
  signLicenceAgreement: async (id: string) =>
    await BttfAxios.patch(
      `/api/investor_pitch_licences/${id}`,
      undefined,
      resp => resp
    ),
};

Object.freeze(AgreementsService);
export default AgreementsService;
